import { render, staticRenderFns } from "./ProductNavigation.vue?vue&type=template&id=3778b13a&scoped=true"
import script from "./ProductNavigation.vue?vue&type=script&lang=ts"
export * from "./ProductNavigation.vue?vue&type=script&lang=ts"
import style0 from "./ProductNavigation.vue?vue&type=style&index=0&id=3778b13a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3778b13a",
  null
  
)

export default component.exports